import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const STAGES = [
  { key: "RAW_MATERIAL", label: "Raw Material" },
  { key: "KILN_FIRING", label: "Kiln Firing" },
  { key: "QA", label: "QA" },
  { key: "DISPATCHED", label: "Dispatched" },
];

export default function BuyerOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders").then(({ data }) => setOrders(data)); }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="buyer-orders">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">My orders</h1>
        <p className="text-muted-foreground">Track manufacturing milestones in real time.</p>
      </div>

      <div className="space-y-4">
        {orders.map((o) => {
          const currentIdx = STAGES.findIndex((s) => s.key === o.current_stage);
          return (
            <div key={o.id} className="surface-card p-6" data-testid={`buyer-order-${o.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="label-overline">Order #{o.id.slice(0, 8)}</div>
                  <div className="font-display text-lg font-black mt-1">{o.tile_size} · {o.finish}</div>
                  <div className="text-xs text-muted-foreground font-mono mt-1">From {o.vendor_name} · {o.quantity_boxes} boxes</div>
                </div>
                <div className="text-right">
                  <Badge variant="outline" className="font-mono text-[10px]">{o.current_stage}</Badge>
                  <div className="font-display font-black text-primary mt-2">₹{(o.total_price || 0).toLocaleString()}</div>
                </div>
              </div>
              <div className="mt-5 grid grid-cols-4 gap-2">
                {STAGES.map((s, i) => {
                  const done = i < currentIdx;
                  const active = i === currentIdx;
                  return (
                    <div key={s.key} className={`p-3 rounded-md border ${active ? "border-primary bg-primary/5" : done ? "border-border bg-muted" : "border-dashed border-border"}`}>
                      <div className="label-overline">{s.label}</div>
                      <div className="text-xs mt-1 font-mono">{done ? "✓ done" : active ? "active" : "pending"}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        {orders.length === 0 && <div className="surface-card p-8 text-center text-sm text-muted-foreground" data-testid="buyer-orders-empty">No orders yet — award an RFQ bid to create one.</div>}
      </div>
    </div>
  );
}
